import { InsuranceCategory, InsuranceGroup, JobStatus, LegacyInterest, PageDefaults } from './types';

declare global {
  const craftConfig: {
    insuranceGroup: InsuranceGroup | 'na';
    insuranceCategory: InsuranceCategory | 'na';
    jobStatus: JobStatus | 'na';
    interest: LegacyInterest;
    isExpat: boolean;
    pageArtifactsGroup: string;
    pageFunnelPosition: string;
    pageFunnelDetail: string;
  };
}

//set global Pagesettings
const { insuranceCategory, insuranceGroup, jobStatus, interest, isExpat } = craftConfig;
export const pageSettings: PageDefaults = {
  isExpat,
  interest,
  ...(insuranceGroup !== 'na' && { insuranceGroup }),
  ...(insuranceCategory !== 'na' && { insuranceCategory }),
  ...(jobStatus !== 'na' && { jobStatus })
};
